module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "gallery-container"
    }
  }, [_c('lazy-component', [_c('div', {
    staticClass: "container",
    attrs: {
      "id": "gallery"
    }
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "id": "gallery-mobile"
    }
  }, [_c('div', {
    staticClass: "col-md-offset-2 col-sm-offset-1 col-sm-10 col-md-8"
  }, _vm._l((_vm.footer.array), function(item, index) {
    return _c('image-loader', {
      staticClass: "image-loader-container",
      attrs: {
        "imgSrc": _vm.path + item.img
      }
    })
  }))])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4869c45c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FooterImage.vue
// module id = 136
// module chunks = 2